import React from "react";
import globe from "../../assets/images/globe.svg";
import PermissionGate from "../PermissionGate";

const NoEntityAvailable = ({ message }) => {
  return (
    <div className="no-entity-container">
      <div className="icon-container">
        <img src={globe} alt="" />
      </div>
      <div className="header-text">
        <h3>{message ? message : "No child entities registered yet"}</h3>
      </div>
      <PermissionGate resource="entity" action="create">
        {!message && (
          <>
            <div className="desc-container">
              <p>Let's add your first one</p>
            </div>
            <div className="btn-container">
              <button className="download-csv">Onboard New Entity +</button>
            </div>
          </>
        )}
      </PermissionGate>
    </div>
  );
};

export default NoEntityAvailable;
